import { TableDataItem } from 'types'

export const injectAdditionalDataToTableData = (
  data: TableDataItem[],
  additionalData?: TableDataItem[],
  additionalDataHeader?: string,
): TableDataItem[] => {
  if (!additionalData?.length) {
    return data
  }

  return [
    ...data,
    { name: additionalDataHeader, subRows: additionalData },
  ] as TableDataItem[]
}
